export const DEFAULT_CARDANO_CHAIN_ID = process.env.VUE_APP_DEFAULT_CARDANO_ID || '1';
